import styled from 'styled-components';

const ContainerStyled = styled.div.attrs({
  className: 'container',
})`
  width: 100%;
  max-width: 35.25rem;
  display: block;
  padding: 1.25rem;
  margin: 0 auto;
`;

export default ContainerStyled;
